<script>
	import { cn } from "./cn.js";
	let className = "";
	export { className as class };
</script>

<div
	class={cn(
		"tw-rounded-xl tw-border tw-border-border tw-bg-card tw-text-card-foreground tw-shadow-sm",
		className,
	)}
	{...$$restProps}
>
	<slot />
</div>
